module.exports = __webpack_public_path__ + "static/media/bootcamp.72c69d0d.jpg";